const GoogleLocalListingsChannel = require('./definitions/GoogleLocalListingsChannel');
const GoogleLocalInventoryAdsChannel = require('./definitions/GoogleLocalInventoryAdsChannel');
const WebhookChannel = require('./definitions/WebhookChannel');
const MetaCommerceChannel = require('./definitions/MetaCommerceChannel');
const ProductReservationsChannel = require('./definitions/ProductReservationsChannel');
const ProductLocatorChannel = require('./definitions/ProductLocatorChannel');
const StorefrontChannel = require('./definitions/StorefrontChannel');
const LocalCheckoutChannel = require('./definitions/LocalCheckoutChannel');
const UberEatsChannel = require('./definitions/UberEatsChannel');
const DeliverooChannel = require('./definitions/DeliverooChannel');
const JustEatChannel = require('./definitions/JustEatChannel');
const MetaCommerceFeedChannel = require('./definitions/MetaCommerceFeedChannel');
const TikTokShopFeedChannel = require('./definitions/TikTokShopFeedChannel');
const PinterestFeedChannel = require('./definitions/PinterestFeedChannel');
const SnapStoreFeedChannel = require('./definitions/SnapStoreFeedChannel');
const SearchWidgetChannel = require('./definitions/SearchWidgetChannel');

/**
 * @type {(typeof import('./model/ChannelDefinition'))[]}
 */
const definitions = [
	GoogleLocalListingsChannel,
	GoogleLocalInventoryAdsChannel,
	WebhookChannel,
	MetaCommerceChannel,
	ProductLocatorChannel,
	StorefrontChannel,
	ProductReservationsChannel,
	LocalCheckoutChannel,
	UberEatsChannel,
	DeliverooChannel,
	JustEatChannel,
	MetaCommerceFeedChannel,
	TikTokShopFeedChannel,
	PinterestFeedChannel,
	SnapStoreFeedChannel,
	SearchWidgetChannel
];

/**
 * @type {import('./model/ChannelDefinition')[]}
 */
module.exports = Object.fromEntries(
	definitions.map((definition) => {
		const channel = new definition();
		return [channel.id, channel.toJSON()];
	})
);
